//include 9
jQuery(function () {

    var endpoint = window.pixelpoint.domainService.get('apiEndpoint') + "search/meta/%Q%";
    var delay = 250;

    var allowed = ['regions', 'locations', 'aquaticsdistrict', 'nationallandscapes', 'excursions'];

    var translations = {
        'default': window.ppt.translate('default', 'Default'),
        'regions': window.ppt.translate('regions', 'Regionen'),
        'locations': window.ppt.translate('locations', 'Orte'),
        'pois': window.ppt.translate('pois', 'Pois'),
        'aquaticsdistrict': window.ppt.translate('watersportregions', 'Wassersportreviere'),
        'nationallandscapes': window.ppt.translate('nationallandscapes', 'Nationale Naturlandschaften'),
        'excursions': window.ppt.translate('excursionregions', 'Ausflugsregionen'),
    }

    var mapTypeMappings = {
        'default': 'excursion.default',
        'regions': 'excursion.region',
        'locations': 'excursion.location',
        'pois': 'excursion.add',
        'aquaticsdistrict': 'excursion.aquaticsdistrict',
        'nationallandscapes': 'excursion.nationallandscapes',
        'excursions': 'excursion.excursions',
    }

    var privateFunctions = {
        init(element) {
            if (element.hasClass("trip-initialised")) {
                return;
            }
            element.addClass("trip-initialised");
            var selectElement = element.find("[data-trip-select]");
            var triggerButton = element.find("[data-trip-add]");

            triggerButton.attr("target", "_blank");

            var cssClass = selectElement.data("dropdown-css-class") || "";

            if (selectElement.length == 0 || triggerButton.length == null) {
                return;
            }

            //************************************************************************************** */
            var dataSources = [];

            $.each(allowed, function (index, single) {
                var engine = new Bloodhound({
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    datumTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: endpoint,
                        cache: false,
                        wildcard: '%Q%',
                        transform(data) {
                            if (!!data[single]) {
                                return _.map(data[single], function (item, name) {
                                    item.group = single;
                                    return item;
                                });
                            }
                            return [];
                        }
                    }
                });
                var translation = translations[single];
                dataSources.push({
                    name: single,
                    display: 'name',
                    source: engine,
                    limit: 100,
                    templates: {
                        header: `<h3>${translation}</h3>`,
                        suggestion: function (data) {
                            var word = data.name;
                            var searchQuery = selectElement.val();
                            word = word.replace(new RegExp(searchQuery, 'gi'), `<strong>$&</strong>`);
                            return `<div>${word}</div>`
                        }
                    }
                });
            });

            selectElement.typeahead(null, dataSources);

            selectElement.bind('typeahead:selected', function (obj, selected) {
                selectElement.data('selected-id', selected.group + ":" + selected.id);
                selectElement.data('last-selected-name', selected.name);
            });

            selectElement.on("blur", function () {
                var currentValue = selectElement.val();
                if (!currentValue)
                    return;
                var lastSelectedName = selectElement.data('last-selected-name');
                if (lastSelectedName != currentValue)
                    selectElement.val("");
            });

            triggerButton.off("click touchstart").on("click touchstart", function (e) {
                var value = selectElement.data("selected-id");

                var type = "";
                var id = 0;
                if (!!value) {
                    var [type, id] = value.split(":");
                }

                if (!type)
                    type = "default";

                //**** tag manager stuff ***********/
                var translation = translations[type] || type;
                var locationName = selectElement.data('last-selected-name');
                window.pixelpoint.tagManager.event("PlanTrip", {
                    type: translation,
                    name: locationName
                });

                //**** ***************** ***********/

                type = mapTypeMappings[type];

                var options = {};
                if (!!id) {
                    options = {
                        id: id
                    };
                }

                if (window.pixelpoint.isMobile.any()) {
                    var link = window.pixelpoint.map.getLink(type, options);
                    triggerButton.attr("href", link);
                } else {
                    e.preventDefault();
                    window.pixelpoint.map.open(type, options);
                }
            });
        }
    };


    window.pixelpoint.map = window.pixelpoint.map || {};
    window.pixelpoint.map.trip = {
        init(elements) {
            elements.each(function () {
                privateFunctions.init($(this));
            });
        }
    };

    window.pixelpoint.map.trip.init($("[data-select-trip-start]"));


    //**********a hack******
    $(".twitter-typeahead input").each(function () {
        var placeholder = $(this).data("placeholder") || "";
        if (!!placeholder) {
            $(this).attr("aria-label", placeholder);
        }
    });
    //**********************

});